<template>
  <volcan-content class="index">
    <volcan-card-layout title="Tableau de bord" icon="fas fa-home">
      <volcan-card-content>
        <div class="row">
          <div class="col-12">
            <p>Bienvenue sur la plateforme d'administration de Volcan.</p>
          </div>
        </div>
      </volcan-card-content>
    </volcan-card-layout>
  </volcan-content>
</template>
<script>
  export default {
    name: 'dashboard',
    components: {},
    data() {
      return {}
    },
    beforeMount() {
      this.$headerTitle = this.$t('dashboard')
    },
    mounted() { },
    methods: {},
    computed: {}
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// shared/dashboard.vue